import { Container } from 'inversify';

let container = new Container();

export function resetContainer(): Container {
  // Certains décorateurs résolvent leurs dépendances via cette référence globale au niveau du module.
  // Créer un `new Container()` séparé dans les tests ne suffit donc pas :
  // ces décorateurs continueraient à lire l'ancienne instance globale importée depuis ce fichier.
  container = new Container();
  return container;
}

export { container };
